var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notifications"}},_vm._l((_vm.items),function(item,index){return _c('NotificationItem',{key:index,attrs:{"color":item.color,"icon":item.icon,"message":item.message}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }